module.exports={"flag":"","geoJSON":{},"ISO":{},"provinces":["Clipperton Island"],"tld":[],"wiki":"http://en.wikipedia.org/wiki/clipperton_island"}